export const EMAIL_REGEX = '^.+@.+\\.[a-zA-Z]{2,63}$'

export const MAXIMUM_FIELD_NAME_LENGTH = 150
